import { sortMethodMap, SORT_EQUAL } from '@/helpers/sort-helpers'

export default class DataTableSortStrategy {
  /**
   * @param {Object<string, Function|{method: string, getValue?: Function>} [config]}
   */
  constructor(config = {}) {
    this.config = config
  }

  sort = (items, sortBy, sortDesc) => {
    if (!items?.length || !sortBy?.length) return items

    return [...items].sort(this._createComparator(sortBy, sortDesc))
  }

  _createComparator(sortBy, sortDesc) {
    const sortByWithConfig = sortBy.map((headerKey, i) => {
      const { method, getValue } = this.config[headerKey]
      const isDesc = Array.isArray(sortDesc) ? sortDesc[i] : sortDesc

      return {
        sortMethod: sortMethodMap[method],
        sortValue: getValue,
        sortDirection: isDesc ? -1 : 1,
      }
    })

    return (a, b) => {
      for (const { sortMethod, sortValue, sortDirection } of sortByWithConfig) {
        const sortResult = sortMethod(sortValue(a), sortValue(b))

        if (sortResult !== SORT_EQUAL) return sortResult * sortDirection
      }
      return SORT_EQUAL
    }
  }
}
